import { SCROLLBAR_HARMONISATION_ATTRIBUTE } from './constants';

interface Controller {
	references: number;
	release: () => void;
}

const controllers = new WeakMap<Document, Controller>();

/**
 * Enables the harmonised scrollbar appearance for one document.
 *
 * Repeated installation is reference counted so separate React roots do not
 * disable the appearance while another root still uses it.
 */
export function installScrollbarHarmonisation(targetDocument: Document): () => void {
	const existingController = controllers.get(targetDocument);

	if (existingController) {
		existingController.references += 1;
		let isReleased = false;

		return () => {
			if (isReleased) {
				return;
			}

			isReleased = true;
			existingController.references -= 1;

			if (existingController.references === 0) {
				existingController.release();
				controllers.delete(targetDocument);
			}
		};
	}

	const rootElement = targetDocument.documentElement;
	const controller: Controller = {
		references: 1,
		release: () => rootElement.removeAttribute(SCROLLBAR_HARMONISATION_ATTRIBUTE),
	};

	rootElement.setAttribute(SCROLLBAR_HARMONISATION_ATTRIBUTE, '');
	controllers.set(targetDocument, controller);

	let isReleased = false;
	return () => {
		if (isReleased) {
			return;
		}

		isReleased = true;
		controller.references -= 1;

		if (controller.references === 0) {
			controller.release();
			controllers.delete(targetDocument);
		}
	};
}
